import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import profileImage from './../../img/profile-photo.png';

export default class Settings extends React.Component<RouteComponentProps<{}>, {}> {
    public render() {
        return <div className="container">
            <div className="animated fadeIn">
                <div className="breadcrumb-block clearfix">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                        <li className="breadcrumb-item active">My account</li>
                    </ol>
                    <span className="text-right current-date">4:14, Thursday, June 22, 2017</span>
                </div>
                <div className="user-actions change-photo clearfix">
                    <figure className="profile-photo">
                        <img src={profileImage} alt="Profile Photo" title="Profile Photo" />
                    </figure>
                    <a href="#" className="edit-profile-photo">Edit Image</a>
                </div>
                <div className="card card--form">
                    <div className="card-block">
                        <form name="form" className="form">
                            <h4 className="block-title">Account Settings</h4>
                            <div className="form-wrapper">
                                <div className="field-group">
                                    <span className="field-label">Name</span>
                                    <input type="text" className="form-control" id="job_name" />
                                </div>
                                <div className="field-group">
                                    <span className="field-label">Address</span>
                                    <input type="text" className="form-control" id="address" />
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">City</span>
                                        <input type="text" className="form-control" id="city" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">State</span>
                                        <input type="text" className="form-control" id="state" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Zip</span>
                                        <input type="text" className="form-control" id="zip" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Phone</span>
                                        <input type="text" className="form-control" id="phone" />
                                    </div>
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Extension</span>
                                        <input type="text" className="form-control" id="extension" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Fax</span>
                                        <input type="text" className="form-control" id="fax" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Email</span>
                                        <input type="text" className="form-control" id="email" />
                                    </div>
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Group</span>
                                        <select id="type" className="form-control select2-single">
                                            <option>Option 1</option>
                                            <option>Option 2</option>
                                            <option>Option 3</option>
                                            <option>Option 4</option>
                                            <option>Option 5</option>
                                        </select>
                                    </div>
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Permission</span>
                                        <a href="#" data-toggle="modal" data-target="#largeModal">User Permission Settings</a>
                                    </div>
                                </div>
                            </div>
                            <div className="form-section">
                                <h4 className="block-title">Change your Password</h4>
                                <div className="form-wrapper label-style1">
                                    <div className="row">
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Old Password</span>
                                            <input type="text" className="form-control" id="old-password" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">New Password</span>
                                            <input type="text" className="form-control" id="new-password" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Re - enter Password</span>
                                            <input type="text" className="form-control" id="confirm-password" />
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="form-actions">
                                <div className="text-center">
                                    <button type="submit" className="btn btn-primary">Save Changes</button><a href="#">Cancel</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
            <div className="modal fade" id="largeModal" tabIndex={-1} role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="vertical-alignment-helper">
                    <div className="modal-dialog modal-lg vertical-align-center" role="document">
                        <div className="modal-content">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <i className="icon-close"></i>
                            </button>
                            <h4 className="modal-title">Permission</h4>
                            <div className="expander-block">
                                <a className="expander-panel" href="#">Super User</a>
                                <div className="collapse-block">
                                    <div className="check-box"><input className="custom-checkbox" id="selectall" type="checkbox" /><label htmlFor="selectall">Select All</label></div>
                                    <div className="check-box"><input className="custom-checkbox" id="view_only" name="view_only" type="checkbox" value="view_only" /><label htmlFor="view_only">View Only</label></div>
                                    <div className="check-box"><input className="custom-checkbox" id="edit" name="edit" type="checkbox" value="edit" /><label htmlFor="edit">Edit</label></div>
                                    <div className="check-box"><input className="custom-checkbox" id="delete" name="delete" type="checkbox" value="delete" /><label htmlFor="delete">Delete</label></div>
                                </div>
                            </div>
                            <div className="expander-block">
                                <a className="expander-panel" href="#">Sales</a>
                                <div className="collapse-block">
                                    <div className="check-box"><input className="custom-checkbox" id="selectall1" type="checkbox" /><label htmlFor="selectall1">Select All</label></div>
                                    <div className="check-box"><input className="custom-checkbox" id="view_only1" name="view_only" type="checkbox" value="view_only" /><label htmlFor="view_only1">View Only</label></div>
                                    <div className="check-box"><input className="custom-checkbox" id="edit1" name="edit" type="checkbox" value="edit" /><label htmlFor="edit1">Edit</label></div>
                                    <div className="check-box"><input className="custom-checkbox" id="delete1" name="delete" type="checkbox" value="delete" /><label htmlFor="delete1">Delete</label></div>
                                </div>
                            </div>
                            <div className="expander-block">
                                <a className="expander-panel" href="#">Support</a>
                                <div className="collapse-block">
                                    <div className="check-box"><input className="custom-checkbox" id="selectall2" type="checkbox" /><label htmlFor="selectall2">Select All</label></div>
                                    <div className="check-box"><input className="custom-checkbox" id="view_only2" name="view_only" type="checkbox" value="view_only" /><label htmlFor="view_only">View Only</label></div>
                                    <div className="check-box"><input className="custom-checkbox" id="edit2" name="edit" type="checkbox" value="edit" /><label htmlFor="edit">Edit</label></div>
                                    <div className="check-box"><input className="custom-checkbox" id="delete2" name="delete" type="checkbox" value="delete" /><label htmlFor="delete">Delete</label></div>
                                </div>
                            </div>
                            <div className="expander-block">
                                <a className="expander-panel" href="#">Item</a>
                                <div className="collapse-block">
                                    <div className="check-box"><input className="custom-checkbox" id="selectall3" type="checkbox" /><label htmlFor="selectall3">Select All</label></div>
                                    <div className="check-box"><input className="custom-checkbox" id="view_only3" name="view_only" type="checkbox" value="view_only" /><label htmlFor="view_only3">View Only</label></div>
                                    <div className="check-box"><input className="custom-checkbox" id="edit3" name="edit" type="checkbox" value="edit" /><label htmlFor="edit3">Edit</label></div>
                                    <div className="check-box"><input className="custom-checkbox" id="delete3" name="delete" type="checkbox" value="delete" /><label htmlFor="delete3">Delete</label></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/account/Settings.tsx